import moment from 'moment';
import { em, rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import styled, { css, withTheme } from 'styled-components';
import DestinationFromTo from '../../components/DestinationFromTo';
import Icon from '../../components/Icon';
import { ticketTypesByValue } from '../../containers/ConnectionForm';
import { formatPrice, getProp, __ } from '../../utilities';

export const Wrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius};
  width: 100%;
  margin-bottom: ${em(10)};
  ${({ small }) =>
    small &&
    css`
      font-size: 13px;
    `};
`;

export const TravelBox = styled.div`
  box-sizing: border-box;
  flex-grow: 1;
  background-color: ${({ theme }) => theme.color.white};
  width: 100%;
  box-shadow: ${({ theme }) => theme.shadow};
  display: flex;
  flex-direction: column;
  position: relative;
  padding-left: ${em(30)};
  padding-right: ${em(30)};
  padding-bottom: ${em(15)};
  ${({ small }) =>
    small &&
    css`
      padding: 0 ${em(15)} ${em(15)} ${em(15)};
    `};
`;

export const DateAndSeats = styled.div`
  font-size: 0.8em;
  line-height: 1.4;
  letter-spacing: ${rem(0.2)};
  color: ${({ theme }) => theme.color.notFound};
`;

const Cell = styled.div`
  font-size: ${em(16)};
  letter-spacing: ${em(0.2)};
  color: ${({ theme }) => theme.color.font.primary};
  display: flex;
  justify-content: flex-start;
  flex-grow: 1;
`;

const GrayCell = styled(Cell)`
  color: ${({ theme }) => theme.color.font.secondary};
  span {
    margin-right: ${em(9)};
  }
`;

export const RoundBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: left;
  margin: ${em(30)} 0;
  ${({ small }) =>
    small &&
    css`
      margin: ${em(15)} 0;
    `};
`;

const PassengerCountBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${em(13)} 0;
  align-items: center;
  border-top: ${rem(1)} solid ${({ theme }) => theme.color.base};
  ${({ small }) =>
    small &&
    css`
      padding: ${em(5)} 0;
      font-size: ${rem(12)};
    `};
`;

export const UpBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const FromTo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: ${em(7)};
  justify-content: center;
`;

const Price = styled.div`
  display: flex;
  white-space: nowrap;
  line-height: 1.5;
  font-weight: bold;
  justify-content: flex-end;
  color: ${({ theme }) => theme.color.primary};
`;

class TicketDetail extends Component {
  render() {
    const {
      small,
      theme,
      ticket: {
        ticket: {
          way1_from: from,
          way1_to: to,
          link,
          join,
          way1_line: way1Line,
          way2_line: way2Line,
          way1_join: way1Join,
          way2_join: way2Join,
          way1_datetime: timeFromWay1,
          way2_datetime: timeFromWay2,
          way1_datetime_dest: timeDestWay1,
          way2_datetime_dest: timeDestWay2,
          tt: ticketType,
          way1_time_utc_ident: way1TimeIdent,
          way2_time_utc_ident: way2TimeIdent,
          way1_time_dest_utc_ident: way1TimeDestIdent,
          way2_time_dest_utc_ident: way2TimeDestIdent,
        },
      },
    } = this.props;
    const timeFromWay1Parsed = moment.parseZone(timeFromWay1);
    const timeDestWay1Parsed = moment.parseZone(timeDestWay1);
    const timeFromWay2Parsed = moment.parseZone(timeFromWay2);
    const timeDestWay2Parsed = moment.parseZone(timeDestWay2);
    return (
      <Wrapper>
        <TravelBox small={small}>
          <RoundBox small={small}>
            <UpBox>
              <Icon
                name="bus"
                size={small ? 'm' : 'l'}
                color={theme.color.primary}
              />
              <FromTo>
                <DestinationFromTo
                  from={from}
                  to={to}
                  font={small ? 12 : 16}
                  center={false}
                  type={ticketType}
                />
                <DateAndSeats>{__(ticketTypesByValue[ticketType])}</DateAndSeats>
                <DateAndSeats>
                  {__('Linka:')} <strong>{way1Line || link}</strong>{' '}
                  {__('Spoj:')} <strong>{way1Join || join}</strong>
                </DateAndSeats>
                <DateAndSeats>
                  {`${timeFromWay1Parsed.format(
                    'HH:mm',
                  )} (${way1TimeIdent}) ${timeFromWay1Parsed.format(
                    'DD. MM. YYYY',
                  )} - ${timeDestWay1Parsed.format(
                    'HH:mm',
                  )} (${way1TimeDestIdent}) ${timeDestWay1Parsed.format(
                    'DD. MM. YYYY',
                  )}`}
                </DateAndSeats>
                {ticketType === 'R' && (
                  <Fragment>
                    <DateAndSeats>{__('Dátum spiatočnej cesty')}</DateAndSeats>
                    <DateAndSeats>
                      {`${timeFromWay2Parsed.format(
                        'HH:mm',
                      )} (${way2TimeIdent}) ${timeFromWay2Parsed.format(
                        'DD. MM. YYYY',
                      )} - ${timeDestWay2Parsed.format(
                        'HH:mm',
                      )} (${way2TimeDestIdent}) ${timeDestWay2Parsed.format(
                        'DD. MM. YYYY',
                      )}`}
                    </DateAndSeats>
                    <DateAndSeats>
                      {__('Linka:')} <strong>{way2Line}</strong> {__('Spoj:')}{' '}
                      <strong>{way2Join}</strong>
                    </DateAndSeats>
                  </Fragment>
                )}
              </FromTo>
            </UpBox>
          </RoundBox>
          {getProp(this.props, ['ticket', 'persons'], []).map(
            (person, index) => {
              const {
                tarrif: { name: ticketName, price_total: totalPrice },
              } = person;
              if (person) {
                return (
                  <PassengerCountBox small={small} key={index.toString()}>
                    <Cell>
                      {`${getProp(person, ['name'])} ${getProp(person, [
                        'surname',
                      ])}`}
                    </Cell>
                    <GrayCell>
                      <Icon
                        name="ticket"
                        size={small ? 's' : 'm'}
                        color={theme.color.font.secondary}
                      />
                      {ticketName}
                    </GrayCell>
                    <Price>{formatPrice(totalPrice)}</Price>
                  </PassengerCountBox>
                );
              }
              return null;
            },
          )}
        </TravelBox>
      </Wrapper>
    );
  }
}

TicketDetail.propTypes = {
  ticket: PropTypes.shape({}).isRequired,
  small: PropTypes.bool,
  theme: PropTypes.shape({}).isRequired,
};

TicketDetail.defaultProps = {
  small: false,
};

export default withTheme(TicketDetail);



// WEBPACK FOOTER //
// ./src/containers/Summary/TicketDetail.js